module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_9005.a02649ef.png";